import { POST, GET } from '@/utils/request'
import Api from './url'

export const getDataInfo = async (params: object) => {
  return await GET({
    url: Api.getDataInfo,
    params,
    showError: false
  })
}
export const firstWatch = async (params: object) => {
  return await GET({
    url: Api.firstWatch,
    params,
    showError: false
  })
}
export const status = async (params: object) => {
  return await GET({
    url: Api.status,
    params,
    showError: false
  })
}
